export default {
  pageTitle: 'ポートフォリオ',
  metaDescription: '製品・材料・国別に見るTEFのプロジェクト実績。世界中に納入した数千件の圧力容器・熱交換器をご紹介します。',
  hero: { title: 'ポートフォリオ' },
  section: {
    heading: 'ポートフォリオ',
    experiencedTitle: '取扱実績のある材料・設備',
    achievements: {
      title: '実績（1998年～2024年9月）',
      projectsSuffix: 'プロジェクト',
      exportedPrefix: '輸出先',
      countriesSuffix: 'カ国',
      fabricationPrefix: '取扱材料',
      typeOfMaterialsSuffix: '種類以上',
      customersPrefix: '顧客数',
      customersSuffix: '社以上',
      plantsSuffix: 'プラント',
    },
    materialCategories: {
      title: '材料カテゴリー',
      examplePrefix: '例：',
      niBaseAlloy: 'ニッケル基合金',
      titaniumZirconium: 'チタン・ジルコニウム',
      duplexSteel: '二相ステンレス鋼（デュプレックス鋼）',
      austeniticSS: 'オーステナイト系ステンレス鋼',
      others: { name: 'その他', example: '銅ニッケル、炭素鋼' },
    },
    applicationAreas: {
      title: '適用分野',
      towerColumn: '塔槽類',
      vesselReactor: '容器・反応器',
      heatExchanger: '熱交換器',
      piping: '配管',
      muffle: 'マッフル',
      radiantTube: 'ラジアントチューブ',
      others: 'その他',
    },
  },
  dashboard: {
    heading: 'ポートフォリオ',
    subheading: '納入実績の内訳（1998年～2024年7月）',
    byProduct: '製品別',
    byMaterial: '材料別',
    byCountry: '国別',
  },
};
